module.exports = __webpack_public_path__ + "img/facilities-icon-1.14200256.svg";